import React from 'react';
import Banner5 from '../images/Banner5.png';
import './HowItWorksSection.css';

const HowItWorksSection = () => {

  return (
    <section id="how-it-works" className="how-it-works-section">
      <div className="how-it-works-wrapper">
        <div className="banner-container">
          <img src={Banner5} alt="How Infinitus 2.0 Works" className="process-banner" />
          <div className="overlay-header">
            <div className="header-content">
              <div className="header-left">
                <h1 className="clients-title">How It <br />
                  Works</h1>
              </div>
              <div className="header-right">
                <p className="clients-subtitle">
                  Our integrated monitoring platform follows a systematic<br />
                  approach to deliver real-time decision intelligence
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
